/**
 * The code-split boundary for the whole /organization section (P4.6-C).
 *
 * Mirrors AdminPanel.tsx exactly, for the same two reasons it gives: main.tsx
 * is an entry module with no exports (defining a component there trips
 * react-refresh/only-export-components), and keeping the boundary beside the
 * tree it guards means main.tsx needs to know nothing about this section
 * beyond one route.
 *
 * WHY CODE-SPLIT AT ALL, given this is the same identity plane as the tenant
 * pages: the audience is disjoint. An owner/rep will never open a single page
 * in here — ProtectedRoute redirects them out — so shipping the org panel,
 * its wizard and its tables in the main bundle would make every builder in
 * the product download a section they can never reach. That is the same
 * argument P4.6-B made for /admin, and it holds here for the same reason,
 * even though the AUTH story is completely different.
 */
import { Suspense, lazy } from "react";

// `.then` re-shapes the named export into the default `lazy()` expects,
// keeping this repo's named-export convention rather than adding a default
// export purely for lazy()'s benefit.
const OrganizationRoot = lazy(() =>
  import("./OrganizationRoot").then((m) => ({ default: m.OrganizationRoot })),
);

export function OrganizationPanel() {
  return (
    <Suspense
      fallback={
        // A real <main> + <h1>, so RouteFocusManager has a heading to focus
        // while the chunk downloads and axe's landmark-one-main /
        // page-has-heading-one rules hold in this transient state too.
        <main className="loading-screen">
          <h1>Loading organization…</h1>
        </main>
      }
    >
      <OrganizationRoot />
    </Suspense>
  );
}
